import React, { FC, useEffect } from 'react';
import { Controller } from 'react-hook-form';
import { CheckedIcon, HelpIcon } from '@src/svg';
import { ControlledCheckboxPropsType } from '@uikit/FormItems/constants';
import { toast } from 'react-toastify';

export const ControlledCheckbox: FC<ControlledCheckboxPropsType> = ({
  name,
  control,
  rules,
  title,
  disabled,
  onChange,
  info,
  className,
  iconWidth = 24,
  iconHeight = 24,
  iconColor = 'currentColor',
  dataTestId,
}) => {
  return (
    <label
      className={`input-checkbox ${disabled ? 'disabled' : ''} ${className || ''}`}
      data-test-id={`${dataTestId}-controlled-checkbox`}
    >
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState, formState }) => {
          useEffect(() => {
            if (formState.isSubmitting && fieldState.error) {
              const message = fieldState.error?.message;
              message && toast.error(message);
            }
          }, [formState.isSubmitting, fieldState.error]);

          return (
            <>
              <input
                data-test-id={`${dataTestId}-checkbox-input`}
                {...field}
                id={name}
                type="checkbox"
                disabled={disabled}
                checked={!!field.value}
                onChange={(e) => {
                  const checked = e.target.checked;
                  field.onChange(checked);
                  onChange && onChange(name, checked);
                }}
              />
              <span className="span-input">
                <CheckedIcon
                  width={iconWidth}
                  height={iconHeight}
                  color={iconColor}
                />
              </span>
            </>
          );
        }}
      />
      <p>{title}</p>
      {info?.toggle && (
        <span className="icon">
          <>
            <HelpIcon />
            <span>{info.desc}</span>
          </>
        </span>
      )}
    </label>
  );
};
